module.exports = require('./helpers/bundle-url').getBundleURL('eR9sC') + "logo.c51670a8.svg";